module.exports = __webpack_public_path__ + "static/BT-desktop-1-631011d7d2160733205e5bb908fa6629.jpg";